import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface StandardizeContractListItem {
  id: number | string;
  codeName: string;
  contractType: string;
  parties: string;
  statusCksNld: string;
  statusReview: string;
  statusStandardized: string;
}

export interface StandardizeContractListDialogData {
  contracts: StandardizeContractListItem[];
  maxContracts: number;
}

@Component({
  selector: 'app-standardize-contract-list-dialog',
  templateUrl: './standardize-contract-list-dialog.component.html',
  styleUrls: ['./standardize-contract-list-dialog.component.scss']
})
export class StandardizeContractListDialogComponent implements OnInit {
  readonly displayedColumns: string[] = ['stt', 'codeName', 'contractType', 'parties'];
  readonly contracts: StandardizeContractListItem[] = [];
  readonly maxContracts: number;
  listContractValid: StandardizeContractListItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: StandardizeContractListDialogData,
    private dialogRef: MatDialogRef<StandardizeContractListDialogComponent>
  ) {
    this.contracts = data && data.contracts ? data.contracts : [];
    this.maxContracts = data && data.maxContracts ? data.maxContracts : 50;
  }

  ngOnInit() {
    this.listContractValid = this.contracts.filter(contract => contract.statusStandardized === 'LACKING_CONDITIONS');
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    const listId = this.listContractValid.map(e => e.id);
    this.dialogRef.close(listId);
  }
}
